module.exports = __webpack_public_path__ + "img/11.1.2e06aa41.png";